// @import types
import { IHttpResponse } from 'app_types/httpTypes'
import {IMyCourse} from 'app_types/campus/academic/myCoursesTypes'
import { CourseSchedulingCourseType } from 'app_types/admin/courseScheduling/courseSchedulingTypes'
import { CourseFormationType } from 'app_types/admin/course/courseTypes'
// @end

export interface ICourseComponent {
  key: string,
  elementType: 'course' | 'moocs' | 'training' | 'training_v2'
}

export const FORMATION_TYPE_TRANSLATIONS = {
  [CourseFormationType.COURSE]: "Curso",
  [CourseFormationType.PROGRAM]: "Programa",
  [CourseFormationType.DIPLOMA]: "Diplomado",
}

export enum CourseScreenSlug {
  COURSE_SCHEDULING = 'course_scheduling',
  PROGRAM = 'program',
  COURSE_SLUG = 'course_slug'
}

export interface IContentEditorJs{
  blocks: any[]
  time: number
  version: string
}

export interface ICourseExtraInfo {
  content?: Array<{category: string, data: string, name: string}>
  coverUrl?: string
  alternative_title?: string
  is_alternative_title_active?: string
  platform_video?: string
  url_video?: string
  short_description?: any
  description?: any
  requirements?: any
  competencies?: IContentEditorJs
  focus?: IContentEditorJs
  generalities?: IContentEditorJs
  important_info?: IContentEditorJs
  materials?: IContentEditorJs
  methodology?: IContentEditorJs
  objectives?: IContentEditorJs
  duration?: string
  slug?: string
  formationType?: CourseFormationType
  schedulingMode?: {
    _id: string,
    name: string
  }
}

// @add your types
export interface ICourse extends ICourseComponent {
  _id: string,
  slug_type: 'course_scheduling' | 'program'
  duration?: number,
  endDate?: string
  endPublicationDate?: string
  enrollmentDeadline?: string
  enrollment_enabled?: boolean
  extra_info: ICourseExtraInfo
  hasCost?: boolean
  priceCOP?: number
  priceUSD?: number
  discount?: number
  endDiscountDate?: string
  program?: {
    code?: string
    name?: string
  },
  schedulingMode?: {
    _id: string,
    name: string
  }
  city?: {
    _id: string,
    name: string
  }
  startDate?: string
  startPublicationDate?:  string
  moodle_id?: string,
  schedule?: string
  custom_training?: {
    modality?: string;
    city?: string;
    price?: string
    video?: {
      platform?: string;
      url?: string
    }
  }
  typeCourse?: CourseSchedulingCourseType
  serviceValidity?: number
  serviceInformation?: string
  withoutTutor?: boolean
  quickLearning?: boolean
}

export interface IFetchCourses extends IHttpResponse {
  courses: Array<ICourse>,
  nPerPage: number,
  pageNumber: number,
  total_register: number
}

export interface IGetActivePublicFilters extends IHttpResponse {
  code: number
  activeModalities: IFilterItem[]
  filters: IFilterItem[]
}

export interface IFetchCourse extends IHttpResponse {
  course: ICourse,
}

export interface IGenerateCourseFile extends IHttpResponse {
  path: string,
}

export interface IFetchMyCourses extends IHttpResponse {
  current_courses: Array<IMyCourse>
  history_courses: Array<IMyCourse>
}

export interface IFilterItem {
  name: string
  value: string
  type?: string
  typeRelated?: string
  childs?: IFilterItem[]
}
//@end
